/**
 * @author Francesco Napoletano <fnapoletano@ebay.com>
 */
export default class ClickToSlide {
    /**
     * @param element
     */
    constructor(element) {
        this.element = element;
    }

    /**
     * Slide content
     * param e jQuery.Event
     */
    slide(e) {

        let selector = 'click-to-slide';
        let $trigger = $(e.target);
        let $target = $($trigger.data(selector));

        if(typeof($trigger.data(selector)) === 'undefined') {
            $('.slideable:visible').each(function() {
                $(this).slideToggle(300);
                $('.slide-open').show();
                $('.slide-close').hide();
            });
        } else {
            $target.slideToggle(300);
            $('.slide-open').toggle();
            $('.slide-close').toggle();
        }
    }
}
